export default {
  data () {
    return {
      isLoading: false,
      options: null,
      valueTemplate: this.createValueTemplate(this.MODEL().valueTemplate),
      result: '',
      resultHuman: ''
    }
  },
  computed: {
    mapDataSource () {
      return this.source.reduce((result, item) => {
        let key = item[this.options.option.value]
        result[key] = item
        return result
      }, {})
    }
  },
  mounted () {
    this.handle('mounted')
  },
  methods: {
    // PARSER
    parseOptionsTemplate () {
      if (typeof this.options.valueTemplate === 'string' && this.options.valueTemplate.indexOf('${') !== -1) {
        this.valueTemplate = this.createValueTemplate(this.options.valueTemplate)
      } else if (typeof this.options.valueTemplate === 'function') {
        this.valueTemplate = this.options.valueTemplate
      } else {
        this.valueTemplate = this.createValueTemplate(this.MODEL().valueTemplate)
        // eslint-disable-next-line
        console.error('Error value template in filter, apply default', this.config, this.place)
      }
    },
    createPromiseDS (Url, Index, Normalization) {
      return new Promise(resolve => {
        this.APIPromise(Url).then(response => {
          resolve({
            source: response.records.map(item => Object.assign({}, Normalization, item)),
            index: Index
          })
        })
      })
    },
    updateSource (Options, UniqTestField, Root) {
      return new Promise(resolve => {
        if (Options.dataSource) {
          // TODO: create normalization object
          let normalization = Options.normalization.split(',').reduce((acc, val) => {
            if (val) acc[val] = ''
            return acc
          }, {})
          let promises = []
          let source = []

          if (this.$_.isArray(Options.dataSource)) {
            // TODO: Если датаСорс массив, парсим его
            source = Options.dataSource.reduce((acc, item, i) => {
              // TODO: если внутри попадаются ссылки на сорсы фиксируем это
              if (typeof item === 'string') {
                promises.push(this.createPromiseDS(item, i, normalization))
              } else {
                acc.push(Object.assign({}, normalization, item))
              }
              return acc
            }, [])
          } else if (typeof Options.dataSource === 'string') {
            // TODO: если датасорс урл фиксируем
            promises.push(this.createPromiseDS(Options.dataSource, 0, normalization))
          }

          // TODO: если попались урлы на данные ждем загрузки если нет выдаем что есть
          if (promises.length) {
            Promise.all(promises).then(results => {
              // TODO: разворачиваем результат и начинаем его всавлять с конца, чтобы индекс не нарушился
              results.reverse().forEach(result => {
                result.source.reverse().forEach(item => {
                  source.splice(result.index, 0, item)
                })
              })
              Root.source = this.testSourceUniq(source, UniqTestField)
              resolve('source created')
            })
          } else {
            Root.source = this.testSourceUniq(source, UniqTestField)
            resolve('source created')
          }
        } else {
          // eslint-disable-next-line
          console.error('Error dataSource in filter', this.config, this.place)
          throw new Error('error created source')
        }
      })
    },
    testSourceUniq (Source, Key) {
      return Source.reduce((acc, val) => {
        if (!acc.map[val[Key]]) {
          acc.map[val[Key]] = 1
          val[Key] = String(val[Key])
          acc.data.push(val)
        } else {
          // eslint-disable-next-line
          console.warn('Дубликат значения в мултиселекте', this.config, this.place)
        }
        return acc
      }, { data: [], map: {} }).data
    },

    // METHODS
    createValueTemplate (Template) {
      if (typeof Template === 'function') {
        return Template
      } else {
        // eslint-disable-next-line
        return new Function('data, root', `return \`${Template}\``)
      }
    },
    getOriginValue (Val) {
      // TODO: get value from template if need
      let template = (this.options) ? this.options.valueTemplate : this.MODEL().valueTemplate
      // eslint-disable-next-line
      let start = template.indexOf('${data}')
      let end = start + 7 - template.length
      if (Val && typeof Val === 'string' && Val.indexOf(template.slice(0, start)) !== -1) {
        return Val.slice(0, end).slice(start)
      } else {
        return Val
      }
    },
    setDefaultValue () {
      let defaultValue = this.options.defaultValue || this.options.value
      if (defaultValue) {
        this.model = defaultValue
        this.updateRendered()
        this.handle('default')
      }
    }
  }
}
